/**
 * Decides whether an activity's empty posted wait should be filled (and saved)
 * from the park's live feed, and with what. Returns the minutes to save, or
 * null to leave it alone.
 *
 * The activity page is reused as you move from one activity to the next, so
 * for a moment after the URL changes it still holds the previous activity, or
 * the previous activity's place and that place's live wait. Saving then wrote
 * the last ride's wait onto whatever was opened next — a restaurant, a park
 * check-in, the next ride. So nothing is filled until both the activity and
 * its place on hand are the ones the page is showing.
 */
export interface LiveWaitPrefillInput {
  /** The activity the page is showing (from the URL). */
  interactionId: string | undefined;
  /** The doc id the loaded activity data was read from. */
  loadedInteractionId: string | null;
  interaction: { entityId?: string | null; postedWait?: number | null } | null;
  /** The doc id the loaded place was read from. */
  loadedEntityId: string | null;
  entityLoading: boolean;
  /** The loaded place records its wait as a posted wait. */
  postedWaitMode: boolean;
  liveWaitLoading: boolean;
  liveWaitMinutes: number | null;
  /** What the posted-wait box currently holds. */
  inputText: string;
}

export function liveWaitToPrefill(input: LiveWaitPrefillInput): number | null {
  const { interactionId, interaction } = input;
  if (!interactionId || !interaction) return null;
  if (input.loadedInteractionId !== interactionId) return null;
  if (!interaction.entityId || input.loadedEntityId !== interaction.entityId) return null;
  if (input.entityLoading || input.liveWaitLoading) return null;
  if (!input.postedWaitMode) return null;
  if (interaction.postedWait != null) return null;
  if (input.inputText.trim() !== "") return null;
  return typeof input.liveWaitMinutes === "number" ? input.liveWaitMinutes : null;
}
